import { FC, useCallback, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import LineChart from '../components/LineChart';
import { fetchScanHistoryData } from '../actions/scan-history-actions';
import { useSnapshot } from 'valtio';
import ScanHistoryStore from '../stores/scan-history-store';
import ScanDebugInfoModal from '../components/ScanDebugInfoModal';
import { setSelectedScanId } from '../stores/scan-history-store-actions';
import TopBarStore from '../../app/stores/top-bar-store';

const ScanHistoryContainer: FC<
  React.PropsWithChildren<ScanHistoryContainerProps>
> = props => {
  const { classes } = useStyles();
  const { dateRange } = useSnapshot(TopBarStore);
  useEffect(() => {
    fetchScanHistoryData();
  }, [dateRange]);

  const {
    categoryBreakdownData,
    labels,
    timeExecutionData,
    timeFinalizingData,
    timeoutsData,
    selectedScanInfo,
    totalTime,
    errorsData,
  } = useSnapshot(ScanHistoryStore);

  const [detailsOpen, setDetailsOpen] = useState(false);
  const closeDetails = useCallback(() => {
    setDetailsOpen(false);
    setSelectedScanId(null);
  }, []);
  const handleClick = (scanId: string) => {
    setDetailsOpen(true);
    setSelectedScanId(scanId);
  };
  return (
    <>
      {selectedScanInfo && (
        <ScanDebugInfoModal
          open={detailsOpen}
          handleClose={closeDetails}
          scanStartDate={new Date(selectedScanInfo.scanStartDate)}
          scanFinishDate={new Date(selectedScanInfo.scanFinishDate)}
          scanId={selectedScanInfo.scanId}
          scanAdditionalInfo={{
            scanType: selectedScanInfo.scanType,
            ...selectedScanInfo.scanInfoStats,
            ...selectedScanInfo.policyPerCatStats.reduce(
              (acc, item) => ({ ...acc, [item.category]: item.count }),
              {},
            ),
          }}
        />
      )}
      {labels && (
        <div className={classes.chartsContainer}>
          {totalTime && (
            <LineChart
              onClick={handleClick}
              name='Total Time'
              data={totalTime}
              labels={labels}
            />
          )}
          {categoryBreakdownData && (
            <LineChart
              onClick={handleClick}
              name='Category Breakdown'
              data={categoryBreakdownData}
              labels={labels}
            />
          )}

          {timeExecutionData && (
            <LineChart
              onClick={handleClick}
              name='Execution Time'
              data={timeExecutionData}
              labels={labels}
              time
            />
          )}
          {timeFinalizingData && (
            <LineChart
              onClick={handleClick}
              name='Finalizing Time'
              data={timeFinalizingData}
              labels={labels}
              time
            />
          )}
          {timeoutsData && (
            <LineChart
              onClick={handleClick}
              name='Timeouts'
              data={timeoutsData}
              labels={labels}
            />
          )}
          {errorsData && (
            <LineChart
              onClick={handleClick}
              name='Errors'
              data={errorsData}
              labels={labels}
            />
          )}
        </div>
      )}
    </>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  chartsContainer: {
    height: '100%',
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: theme.spacing(2),
    padding: theme.spacing(2),
  },
}));

export interface ScanHistoryContainerProps {}

export default ScanHistoryContainer;
